module.exports = __webpack_public_path__ + "media/images/athletes/1088-3dd83009278f8119cd21450750e4cda7.png";